module.exports = __webpack_public_path__ + "static/media/rest_end.a3e374c0.mp3";